(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const preOrderBlock = document.querySelector('.accelerated-checkout-block--pre-order');
    if (!preOrderBlock) return;

    const buyItNowButton = preOrderBlock.querySelector(
      'shopify-buy-it-now-button > button.shopify-payment-button__button--unbranded'
    );

    buyItNowButton.textContent = 'Pre-order nu';
  });
  } catch(e) { console.error(e); }
})();

})();
